import ScrollLock from 'react-scrolllock';
import styled from 'styled-components';
import { IChildrenProps } from '../../models/utilTypes';
import { COLOR } from '../../styles/colors';
import { dropDownBoxShadowStyles } from '../../styles/css';
import Portal from '../Portal/Portal';

const StyledFlyout = styled.div`
  ${dropDownBoxShadowStyles}
  background-color: ${COLOR.white};

  position: fixed;
  right: 0;
  top: 0;
  z-index: 10000000; // Needed for skybox

  height: 100vh;
  width: 375px;
  transition: width 0.1s ease-in;

  overflow-y: auto;
  overflow-x: hidden;

  padding: 20px;
`;

const StyledFlyoutOverlay = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999999;

  background: ${COLOR.black};
  opacity: 0.3;
  height: 100vh;
  width: 100vw;
`;

interface IFlyoutProps extends IChildrenProps {
  onClose: () => void;
}

const Flyout: React.FC<IFlyoutProps> = ({ onClose, children }) => (
  <Portal portalId="flyout">
    <ScrollLock>
      <StyledFlyout>{children}</StyledFlyout>
    </ScrollLock>
    <StyledFlyoutOverlay onClick={onClose} />
  </Portal>
);

export default Flyout;
